var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VCard",
    { staticClass: "menu--card", attrs: { elevation: "0" } },
    [
      _c("div", { staticClass: "menu--container" }, [
        _c("div", { staticClass: "menu--header" }, [
          _c(
            "div",
            { staticClass: "menu--header-icons-left" },
            [
              _c("IconNookService", {
                staticClass: "menu--header-img menu--header-bars",
              }),
              _vm._v(" "),
              _c("IconNookHead", {
                staticClass: "menu--header-img menu--header-nook",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "menu--time" }, [
              _vm._v(_vm._s(_vm.time)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "menu--header-icons-right" },
            [
              _c("IconNookGPS", {
                staticClass: "menu--header-img menu--header-gps",
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "menu--title" }, [
          _vm._v(_vm._s(_vm.menuTitle)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "menu--nav" },
          [
            _c("router-link", { staticClass: "home", attrs: { to: "/" } }, [
              _c(
                "div",
                {
                  staticClass: "menu--nav-icon-container",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("modal-close")
                    },
                    mouseover: function ($event) {
                      return _vm.enterNavItem("Home")
                    },
                    mouseleave: function ($event) {
                      return _vm.leaveNavItem()
                    },
                  },
                },
                [_c("IconNavHome", { staticClass: "menu--nav-item" })],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "browse", attrs: { to: "/browse" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("modal-close")
                      },
                      mouseover: function ($event) {
                        return _vm.enterNavItem("Browse")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavBrowse", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "editor", attrs: { to: "/editor" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("modal-close")
                      },
                      mouseover: function ($event) {
                        return _vm.enterNavItem("Editor")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavEditor", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("router-link", { staticClass: "faq", attrs: { to: "/faq" } }, [
              _c(
                "div",
                {
                  staticClass: "menu--nav-icon-container",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("modal-close")
                    },
                    mouseover: function ($event) {
                      return _vm.enterNavItem("FAQ")
                    },
                    mouseleave: function ($event) {
                      return _vm.leaveNavItem()
                    },
                  },
                },
                [_c("IconNavFaq", { staticClass: "menu--nav-item" })],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "about", attrs: { to: "/about" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("modal-close")
                      },
                      mouseover: function ($event) {
                        return _vm.enterNavItem("About Us")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavAbout", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "updates", attrs: { to: "/updates" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("modal-close")
                      },
                      mouseover: function ($event) {
                        return _vm.enterNavItem("Updates")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavUpdates", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "discord",
                attrs: {
                  href: "https://discord.com/invite/9rGkZNk",
                  target: "_blank",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      mouseover: function ($event) {
                        return _vm.enterNavItem("Discord")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavDiscord", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "twitter",
                attrs: {
                  href: "https://twitter.com/acpatterns",
                  target: "_blank",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu--nav-icon-container",
                    on: {
                      mouseover: function ($event) {
                        return _vm.enterNavItem("Twitter")
                      },
                      mouseleave: function ($event) {
                        return _vm.leaveNavItem()
                      },
                    },
                  },
                  [_c("IconNavTwitter", { staticClass: "menu--nav-item" })],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("CancelButton", {
        staticClass: "nav-menu-cancel",
        on: {
          click: function ($event) {
            return _vm.$emit("modal-close")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }